import { useEffect,useState } from 'react'
import { useNavigate,useParams } from 'react-router-dom'
import { Alert, Box, Card, CardContent, CircularProgress, Divider, Fade, FormControl, Grid, InputLabel, MenuItem, Modal, Select, SwipeableDrawer, Table, TableBody, TableCell, TableRow, TextField, Typography } from '@mui/material'
import { post } from '../../utils/axios'
import { toast } from 'react-toastify'
import Button from '../../components/Button'

import './Orders.css'

const Orders = () => {

    const navigate = useNavigate()

    const {orderId} = useParams()
    const [isLoading,setIsLoading] = useState(true)
    const [cancelOrderLoading,setCancelOrderLoading] = useState(false)
    const [openModal,setOpenModal] = useState(false)
    const [showLoading,setShowLoading] = useState(false)
    const [totalPrice,setTotalPrice] = useState(0)
    const [orderDetail,setOrderDetail] = useState({})
    const [currentOrderId,setCurrentOrderId] = useState(0)
    const [order,setOrder] = useState({})
    const [orders,setOrders] = useState([])
    const [showDrawer,setShowDrawer] = useState(false)
    const [orderStatus,setOrderStatus] = useState(10)
    const [isShowOnce,setIsShowOne] = useState(false)
    const [cancelDescription,setCancelDescription] = useState('')
    
    const getData = () => {
        setIsLoading(true)
        setOrders([])
        const postedData = {}
        if(orderStatus != 10)
            postedData.orderStatus = parseInt(orderStatus)
        post('Order/GetAllOrder',postedData).then(({data}) => {
            if(data.isSuccess)
                setOrders(data.data)
            // else
            //     toast.error(data.message)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        getData()
    },[orderStatus])

    useEffect(() => {
        if(orders.length && orderId && orders[0].serviceConsumerId != orderId){
            const element = document.getElementById(`order-${orderId}`)
            if(element)
                element.scrollIntoView({behavior: 'smooth'})
        }
    },[orders])

    const handleDrawer = orderId => {
        setShowDrawer(true)
        setShowLoading(true)
        const postedData = {
            serviceConsumerId: orderId
        }
        post('Order/GetOrder',postedData).then(({data}) => {
            if(data.isSuccess){
                let calcTotalPrice = 0
                let generatedOrder = []
                let itemIndex = 0
                const additionalInfo = {}
                data.data.additionalInfo.map(item => {
                    if(item.key != 'description')
                        additionalInfo[item.key] = item.value
                })
                data.data.additionalInfo = additionalInfo
                setOrderDetail(data.data)
                data.data.subServiceId.map(item => {
                    calcTotalPrice += item.price
                    itemIndex = generatedOrder.findIndex(i => i.id === item.id)
                    if(itemIndex != -1){
                        generatedOrder[itemIndex].count = generatedOrder[itemIndex].count + 1
                    }else{
                        generatedOrder.push({...item,count: 1})
                    }
                })
                generatedOrder.additionalInfo = additionalInfo
                setOrder(generatedOrder)
                setTotalPrice(calcTotalPrice)
            }
        }).finally(() => setShowLoading(false))
    }

    useEffect(() => {
        if(orders.length && orderId && !isShowOnce){
            handleDrawer(orderId)
            setIsShowOne(true)
        }
    },[orders])

    const reorder = order => {
        const index = orders.findIndex(item => item.serviceConsumerId == order.serviceConsumerId)
        if(index != -1){
            let oldOrders = [...orders]
            oldOrders[index].isLoading = true
            setOrders(oldOrders)
            const postedData = {
                serviceConsumerId: order.serviceConsumerId
            }
            post('Order/GetOrder',postedData).then(({data}) => {
                if(data.isSuccess){
                    let subServicesId = []
                    data.data.subServiceId.map(subService => subServicesId.push(subService.id))
                    subServicesId = JSON.stringify(subServicesId)
                    localStorage.setItem('reorder',subServicesId)
                    setTimeout(() => {
                        navigate(`/app/businesses/services/${order.businessId}`)
                    },250)
                }
            }).finally(() => {
                oldOrders[index].isLoading = false
                setOrders(oldOrders)
            })
        }
    }

    const cancelOrder = () => {
        setCancelOrderLoading(true)
        const postedData = {
            serviceConsumerId: currentOrderId,
            cancelDescription
        }
        post('Order/CancelOrder',postedData).then(({data}) => {
            if(data.isSuccess){
                toast.success('سفارش با موفقیت لغو شد')
                getData()
                setCancelDescription('')
                setOpenModal(false)
            }
        }).finally(() => setCancelOrderLoading(false))
    }

    const copyDigikalaTrackingCode = trackingCode => {
        if(trackingCode){
            navigator.clipboard.writeText(trackingCode.toString())
            toast.success('کد رهگیری با موفقیت کپی شد')
        }
    }

    const statuses = {
        '1': 'پرداخت نشده',
        '2': 'پرداخت شده',
        '3': 'تایید شده',
        '4': 'ارسال شده',
        '5': 'تحویل شده',
        '6': 'لغو شده'
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '92%',
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    }

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">سفارشات</h3>
            <div className="safe-area">
                <Card key={order.serviceConsumerId} sx={{width: '100%',mb: 2.5}}>
                    <CardContent sx={{py: 3,pb: 4}}>
                        <h5 className="filter-orders-title">مرتب سازی بر اساس</h5>
                        <Grid container spacing={2} mt={2}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>وضعیت سفارش</InputLabel>
                                    <Select value={orderStatus} label="وضعیت سفارش" onChange={e => setOrderStatus(e.target.value)}>
                                        <MenuItem value="10">همه</MenuItem>
                                        <MenuItem value="1">موفق</MenuItem>
                                        <MenuItem value="2">ناموفق</MenuItem>
                                        <MenuItem value="3">در حال پردازش</MenuItem>
                                        {/* <MenuItem value="1">پرداخت نشده</MenuItem>
                                        <MenuItem value="2">پرداخت شده</MenuItem>
                                        <MenuItem value="3">تایید شده</MenuItem>
                                        <MenuItem value="4">ارسال شده</MenuItem>
                                        <MenuItem value="5">تحویل شده</MenuItem>
                                        <MenuItem value="6">لغو شده</MenuItem> */}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                {isLoading ?
                <>{[...Array(3)].map((item,index) => <Card key={index} sx={{width: '100%',mb: 2.5}}>
                    <CardContent sx={{py: 3,pb: 4}}>
                        <Grid container spacing={2} mb={2}>
                            <Grid item xs={3.5}>
                                <img src={'/assets/img/default-logo.jpg'} alt={order.businessTitle} height={85} style={{borderRadius: 5}} />
                            </Grid>
                            <Grid item xs={8.5}>
                                <p className="order-item-detail-placeholder animate"></p>
                                <p className="order-item-detail-placeholder animate"></p>
                                <p className="order-item-detail-placeholder animate"></p>
                                <p className="order-item-detail-placeholder animate"></p>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Button fullWidth variant="contained" className="order-item-detail-button-placeholder animate" disabled sx={{py: 1.3,height: 45}}></Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Button fullWidth variant="contained" className="order-item-detail-button-placeholder animate" disabled sx={{py: 1.3,height: 45}}></Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>)}</>
                : (orders.length ? <Box sx={{mb: 5,background: 'transparent !important'}}>{orders.map(order => <Card key={`${Math.random()}-${order.serviceConsumerId}`} id={`order-${order.serviceConsumerId}`} sx={{width: '100%',mb: 2.5}}>
                    <CardContent sx={{py: 3,pb: 4}}>
                        <Grid container spacing={2} mb={2}>
                            <Grid item xs={3.5}>
                                <img className="order-item-img" src={order.logoPath ? `https://petromah.sabinarya.com${order.logoPath}` : '/assets/img/default-logo.jpg'} alt={order.businessTitle} height={85} style={{borderRadius: 5}} />
                            </Grid>
                            <Grid item xs={8.5}>
                                <p className="order-item-detail">{order.businessTitle}</p>
                                <p className="order-item-detail">وضعیت : {order.statusTitle || '-'}</p>
                                <p className="order-item-detail" dir="ltr">{`${order.registerDate.toString().slice(0,4)}/${order.registerDate.toString().slice(4,6)}/${order.registerDate.toString().slice(6,8)}`} - {order.registerTime}</p>
                                <p className="order-item-detail">شماره سفارش : {order.serviceConsumerId}</p>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            {order.status == 2 && false ? <Grid item xs={12}>
                                <Button fullWidth onClick={() => {setCurrentOrderId(order.serviceConsumerId);setOpenModal(true)}} variant="contained" color="error" sx={{py: 1.3}}>لغو سفارش</Button>
                            </Grid> : ''}
                            <Grid item xs={6}>
                                {order.status == 1 ? <Button fullWidth isLoading={order.isLoading} onClick={() => navigate(`/app/basket/confirm/${order.serviceConsumerId}/repay`)} variant="contained" color="primary" sx={{py: 1.3}}>پرداخت</Button> : <Button fullWidth isLoading={order.isLoading} onClick={() => reorder(order)} variant="contained" color="success" sx={{py: 1.3}}>سفارش مجدد</Button>}
                            </Grid>
                            <Grid item xs={6}>
                                <Button fullWidth onClick={() => handleDrawer(order.serviceConsumerId)} variant="contained" color="secondary" sx={{py: 1.3}}>مشاهده سفارش</Button>
                            </Grid>
                        </Grid>
                        {!order.opinionParticipated && order.opinionToken && order.paymentResponseCode == '00' && (order.guildId == 64 && order.status == 5) ? <Grid container spacing={2} sx={{mt: 0}}>
                            <Grid item xs={12}>
                                <div className="order-opinion-box">
                                    <p>برای این سفارش امتیازی ثبت نکرده اید <span onClick={() => navigate(`/app/orders/poll/${order.opinionToken}/${order.serviceConsumerId}`)}>ثبت نظر</span></p>
                                </div>
                            </Grid>
                        </Grid> : ''}
                    </CardContent>
                </Card>)}</Box> : <Alert severity="info">{orderStatus == 10 ? 'سفارشی ثبت نشده است' : `سفارشی در وضعیت ${statuses[orderStatus] || '-'} یافت نشد`}</Alert>)}
                <SwipeableDrawer anchor="bottom" open={showDrawer} onClose={() => setShowDrawer(false)} onOpen={() => setShowDrawer(true)} className="order-detail-drawer">
                    {showLoading ? <CircularProgress size={28} style={{display: 'table',margin: '25px auto'}} /> : (Object.keys(order).length ? <>
                    <h4>جزئیات سفارش</h4>
                    <Table>
                        <TableBody>
                            {order && order.length ? order.map((item,index) => <TableRow key={index} sx={{'&:last-child td,&:last-child th': {border: 0,marginBottom: 0,paddingBottom: 0.5}}}>
                                <TableCell align="right">{item.title} <i className="fal fa-xmark"></i> {item.count}</TableCell>
                                <TableCell align="right">{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(item.price * item.count)} ریال</TableCell>
                            </TableRow>) : ''}
                            <TableRow sx={{'&:last-child td,&:last-child th': {border: 0,marginBottom: 0,paddingBottom: 3}}}>
                                <TableCell align="right"><b>مجموع</b></TableCell>
                                <TableCell align="right">{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(totalPrice)} ریال</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    {orderDetail.additionalInfo && Object.keys(orderDetail.additionalInfo).length ? <div className="delivery-detail">
                        {!orderDetail.additionalInfo.digi ? <h4>اطلاعات استفاده کننده</h4> : <h4>کد رهگیری دیجی کالا</h4>}
                        {orderDetail.additionalInfo.firstName ? <p className="order-user-detail">نام : <span>{orderDetail.additionalInfo.firstName}</span></p> : ''}
                        {orderDetail.additionalInfo.lastName ? <p className="order-user-detail">نام خانوادگی : <span>{orderDetail.additionalInfo.lastName}</span></p> : ''}
                        {orderDetail.additionalInfo.mobile ? <p className="order-user-detail">شماره همراه : <span>{orderDetail.additionalInfo.mobile}</span></p> : ''}
                        {orderDetail.additionalInfo.nationalCode ? <p className="order-user-detail">کد ملی : <span>{orderDetail.additionalInfo.nationalCode}</span></p> : ''}
                        {orderDetail.additionalInfo.insuranceNo ? <p className="order-user-detail">شماره بیمه : <span>{orderDetail.additionalInfo.insuranceNo}</span></p> : ''}
                        {orderDetail.additionalInfo.digi ? <p className="order-user-detail" onClick={() => copyDigikalaTrackingCode(orderDetail.additionalInfo.digi)}>کد : <span>{orderDetail.additionalInfo.digi}</span></p> : ''}
                    </div> : ''}
                    {orderDetail.agentName && orderDetail.agentMobileNo ? <div className="delivery-detail">
                        <h4>اطلاعات سفیر</h4>
                        <p>نام : <span>{orderDetail.agentName}</span></p>
                        <p>شماره همراه : <a href={`tel:${orderDetail.agentMobileNo}`}>{orderDetail.agentMobileNo}</a></p>
                    </div> : ''}
                    </> : <Box sx={{px: 2}}><Alert severity="info" sx={{my: 3}}>اطلاعات سفارش یافت نشد</Alert></Box>)}
                </SwipeableDrawer>
                <Modal open={openModal} onClose={() => setOpenModal(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Fade in={openModal}>
                        <Box sx={style}>
                            <Typography variant="h6" component="h2" sx={{ fontSize: 18 }}>لغو سفارش</Typography>
                            <Divider sx={{mt: 2,mb: 2.5}} />
                            <TextField sx={{mb: 3}} multiline rows={3} fullWidth={true} label="علت درخواست لغو سفارش" variant="standard" value={cancelDescription} onChange={e => setCancelDescription(e.target.value)} />
                            <Button fullWidth isLoading={cancelOrderLoading} variant="contained" color="primary" sx={{py: 1.5,mt: 1}} disabled={!cancelDescription} onClick={cancelOrder}>لغو سفارش</Button>
                        </Box>
                    </Fade>
                </Modal>
            </div>
        </Grid>
    )

}

export default Orders